module.exports = __webpack_public_path__ + "static/media/content_system_area_android.e14ebb06.png";